import { hasValue } from "../validations/common";

function countDaysBetweenDates(date1, date2) {
  const date1Parsed = new Date(date1);
  const date2Parsed = new Date(date2);

  const milisecondsDiff = Math.abs(date2Parsed - date1Parsed);
  const dayDiff = Math.ceil(milisecondsDiff / (1000 * 60 * 60 * 24));

  return isNaN(dayDiff) ? "0" : dayDiff.toString();
}

const parsePriceCurrency = (price) => {
  if (hasValue(price)) {
    let priceParsed = "";
    const formatter = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    });

    priceParsed = formatter.format(price);
    return priceParsed;
  } else {
    return "-€";
  }
};

const displayDate = (date) => {
  if (!date) return "";

  const dateTime = new Date(date);

  const day = dateTime.getDate().toString().padStart(2, "0");
  const month = (dateTime.getMonth() + 1).toString().padStart(2, "0");
  const year = dateTime.getFullYear().toString();

  return `${day}/${month}/${year}`;
};

const displayDateTime = (date) => {
  if (!date) return "";

  const dateTime = new Date(date);

  const day = dateTime.getDate().toString().padStart(2, "0");
  const month = (dateTime.getMonth() + 1).toString().padStart(2, "0");
  const year = dateTime.getFullYear().toString();

  const hours = dateTime.getHours().toString().padStart(2, "0");
  const minutes = dateTime.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const parseDecimals = (price, decimals) => {
  const parsedPrice = parseFloat(price).toFixed(decimals);
  return parsedPrice.toString().replace(".", ",");
};

const parseDateToUtc = (date) => {
  if (!date) return "";

  let newDate = new Date(date);
  let res = "";
  if (date.trim() !== "") {
    const tzoffset = new Date(date).getTimezoneOffset() * 60000;
    res = new Date(newDate.getTime() - tzoffset).toISOString();
  }
  return res;
};

const parseDateFromUtc = (date) => {
  if (!date) return null;
  const localDateTime = new Date(date + "Z");

  return localDateTime.toString();
};

const displayPercent = (number) => {
  let parsedNumber = parseFloat(number);
  if (parsedNumber > 0) {
    return parsedNumber.toFixed(2) + "%";
  }
  if (parsedNumber === 0) {
    return "0%";
  }
  return "-%";
};

const formatNumber = (number) => {
  let parsedNumber = parseFloat(number);
  if (parsedNumber === 0) {
    return "0";
  }
  if (parsedNumber > 0) {
    return parsedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  return "";
};

const objectToQueryString = (obj, addQuestionMark) => {
  const questionMark = addQuestionMark ? "?" : "";
  return (
    questionMark +
    Object.keys(obj)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
      )
      .join("&")
  );
};

const getPropertyFromArrayObject = (array, property) => {
  if (array !== null && array.length > 0 && array[0] !== undefined) {
    if (array[0].hasOwnProperty(property)) {
      return array.map((objeto) => objeto[property]);
    } else {
      return array;
    }
  } else {
    return [];
  }
};

const getPropertyFromObject = (object, property) => {
  if (object === "" || object === undefined || object === null) {
    return "";
  } else {
    if (object.hasOwnProperty(property)) {
      return object[property];
    } else {
      return object;
    }
  }
};

const getPercent = (value, total) => {
  if (total === 0 || value === 0) {
    return 0;
  }

  let percent = (value / total) * 100;
  return percent.toFixed(2);
};

const accessProperty = (object, property) => {
  if (object === null || object === undefined) return null;
  let dotIndex = property.indexOf(".");
  if (dotIndex > -1)
    return accessProperty(
      object[property.substring(0, dotIndex)],
      property.substring(dotIndex + 1)
    );
  return object[property]?.toString();
};

const getRandomNumber = (max) => {
  const generatedNumbers = new Set();

  const upperLimit = max || 10000000;

  if (generatedNumbers.size >= upperLimit) {
    throw new Error("Todos los números posibles han sido generados.");
  }

  let randomNumber;
  do {
    randomNumber = Math.floor(Math.random() * upperLimit);
  } while (generatedNumbers.has(randomNumber));

  generatedNumbers.add(randomNumber);
  return randomNumber;
};

const bookNumberMask = (bookNumber) => {
  if (bookNumber) {
    let str_bookNumber = bookNumber.toString();

    while (str_bookNumber.length < 6) {
      str_bookNumber = "0" + str_bookNumber;
    }

    return str_bookNumber.match(/.{1,2}/g).join(".");
  } else {
    return "-";
  }
};

const isDateBetweenDates = (date, dateStart, dateEnd) => {
  if (date >= dateStart && date <= dateEnd) {
    return true;
  } else {
    return false;
  }
};

const isDateAndHasValue = (date) => {
  if (date instanceof Date && !isNaN(date.getTime())) {
    return true;
  }
};

const isDateGreaterThan = (date, dateFocus) => {
  if (isDateAndHasValue(date) && isDateAndHasValue(dateFocus)) {
    return date.getTime() > dateFocus.getTime();
  }
};

const isDateLessThan = (date, dateFocus) => {
  if (isDateAndHasValue(date) && isDateAndHasValue(dateFocus)) {
    return date.getTime() < dateFocus.getTime();
  }
};

export {
  countDaysBetweenDates,
  parsePriceCurrency,
  displayDate,
  displayDateTime,
  parseDecimals,
  parseDateToUtc,
  parseDateFromUtc,
  displayPercent,
  formatNumber,
  objectToQueryString,
  getPropertyFromArrayObject,
  getPropertyFromObject,
  getPercent,
  accessProperty,
  getRandomNumber,
  bookNumberMask,
  isDateBetweenDates,
  isDateAndHasValue,
  isDateGreaterThan,
  isDateLessThan,
};
